<template>
	<span class="bouncing-text-holder" v-html="letters"></span>
</template>

<script>
import { wrapCharacters, elementsToStrings } from '@/mixins/text-wrapper';
import { setElementStyles } from '@/mixins/element-attrs';

export default {
	name: 'CycleStarter',
	props: {
		text: {
			default: "",
		},
	},
	computed: {
		letters() {
			const letters = wrapCharacters(this.text, "span");
			letters.forEach((letter, index) => {
				setElementStyles(letter, { 	animationDelay: `.${index}s` });
			});

			const letterHTML = elementsToStrings(letters);
			return letterHTML;
		},
	},
};
</script>

<style lang="scss">
	.bouncing-text-holder {
		white-space: nowrap;
		font-size: 120px;
		font-weight: bold;
		color: #fff;
		text-shadow: 0 1px 0 #ccc,
					0 2px 0 #ccc,
					0 3px 0 #ccc,
					0 4px 0 #ccc,
					0 5px 0 #ccc,
					0 6px 0 transparent,
					0 7px 0 transparent,
					0 8px 0 transparent,
					0 9px 0 transparent,
					0 10px 10px rgba(0, 0, 0, .4);

		@include mobile {
			font-size: 80px;
		}

		span {
			display: inline-block;
			animation: letter-bounce .3s ease infinite alternate;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/BouncingText.vue